import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import WorkflowName from 'automation-ui-references/customer-data/WorkflowName';
import { PLATFORM } from 'automation-ui-flow-core/flow/FlowSourceTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EnrollInFlowActionSummary({
  metadata
}) {
  const {
    flowId
  } = metadata;
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.enroll-in-flow.summary",
    options: {
      flowName: /*#__PURE__*/_jsx(WorkflowName, {
        flowSourceType: PLATFORM,
        id: flowId
      })
    }
  });
}